import { TimeInMilliseconds } from '@malou-io/package-utils';

export const FETCH_DIAGNOSTICS_INTERVAL = 8 * TimeInMilliseconds.SECOND;
export const TREAT_DIAGNOSTICS_INTERVAL = 20 * TimeInMilliseconds.SECOND;
export const DELAY_TO_ADD_DIAGNOSTIC = 1.5 * TimeInMilliseconds.SECOND;
export const DELAY_TO_START_NUMBER_ANIMATION = 0.3 * TimeInMilliseconds.SECOND;
export const DELAY_TO_REMOVE_NEW_3_RANKS_IMAGES = 3 * TimeInMilliseconds.SECOND;
export const DELAY_TO_SCROLL_BACK_TO_TOP = 8 * TimeInMilliseconds.SECOND;
export const FIRE_CONFETTI_INTERVAL = 0.7 * TimeInMilliseconds.SECOND;
export const DELAY_TO_CLOSE_MODAL = 4.5 * TimeInMilliseconds.SECOND;
export const MAX_DIAGNOSTICS_TO_DISPLAY = 100;
